import React from "react";
import AdmissionForm from "../components/otherPageComponent/Admission";
import SEO from "../components/SEO";

function AdmissionPage() {
  return (
    <>
      <SEO
        title="Admission - Aastha Computers"
        description="Join Aastha Computes, Bikaner! Check admission guidelines, eligibility, fees, and enrollment process for our computer classes designed for all ages and skill levels."
        pagePath="/admission"
      />
      <AdmissionForm />
    </>
  );
}

export default AdmissionPage;
